import * as types from "./mutationTypes";
import { getValidationMethod } from "./validators";

export default {
  clearValidator({ commit }) {
    commit(types.CLEAR_VALIDATOR);
  },
  /**
   * Add validator to a field
   * fieldValidations object structure example
   * {
   *  field: String // "field_name",
   *  validations: [
   *    {
   *      method: String|Function //Can be mapped function (REQUIRED, MIN_LENGTH, ...) or custom function
   *      value: Number|String //Optional, value for comparation
   *      message: String //Message string error
   *     }
   *   meta: Object //The meta object that will be use for you view
   *         //can hold adicional information
   *  ]
   * }
   * @param {vuex context} context
   * @param {object validation} fieldValidations
   */
  addValidator({ commit }, fieldValidations) {
    const validations = [];
    fieldValidations.validations.forEach((validation) => {
      //For each validation passed, add method that can be custom or mapped
      let method = validation.method;
      if (typeof method !== "function") {
        method = getValidationMethod(validation.method, validation.value);
      }
      validations.push({
        method: method,
        message: validation.message
      });
    });

    const validator = {
      meta: fieldValidations.meta,
      validations
    };

    commit(types.ADD_VALIDATOR, { field: fieldValidations.field, validator });
  },
  /**
   * Validate field passed by param with value, use validator added before
   * customMessage: if the validation message changes according other data you can
   * change the message exhibited in the field in this parameter
   *
   * @param {vuex context} context
   * @param {object with field and value} param1
   * @param {custom message according validation context} customMessage
   * @returns Boolean
   */
  validate({ commit, state }, { field, value, customMessage }) {
    if (!state.validator[field]) {
      return;
    }

    const validations = state.validator[field].validations;
    for (let i = 0; i < validations.length; i++) {
      const validation = validations[i];
      commit(types.REMOVE_ERROR, field);
      if (!validation.method(value)) {
        commit(types.ADD_ERROR, {
          field,
          message: customMessage || validation.message,
          meta: {
            ...state.validator[field].meta
          }
        });

        return false;
      }
    }

    return true;
  },
  /**
   * Check validation of field passed by parameter according the respective value
   * If validation pass, remove error object
   *
   * @param {vuex context} context
   * @param {object with field and value} param1
   * @returns
   */
  checkValidation({ commit, state }, { field, value }) {
    if (!state.errors) {
      return;
    }
    const errorsField = state.errors.filter((error) => error.field === field);
    if (errorsField.length === 0) {
      //Don't have errors, return
      return;
    }

    if (!state.validator[field]) {
      return;
    }

    //Have errors, verify with the new value
    const validations = state.validator[field].validations;
    for (let i = 0; i < validations.length; i++) {
      const validation = validations[i];
      if (!validation.method(value)) {
        return;
      }
    }
    commit(types.REMOVE_ERROR, field);
  },
  /**
   * Remove field error
   *
   * @param {vuex context} context
   * @param {string} field
   */
  removeError({ commit }, field) {
    commit(types.REMOVE_ERROR, field);
  },
  addError({ commit }, error) {
    commit(types.ADD_ERROR, error);
  }
};
